
<template>
    <div class="vacation_info" v-if="view_action != null">
        <b-badge variant="border-primary" class="border border-primary ">
            Переглянув {{added_text }}
        </b-badge>
    </div>
</template>


<script>
export default {
    name: "doc_watch",
    props: {
        user_id: {
            type: Number,
            required: true,
        },
        doc_id: {
            type: Number,
            required: true,
        },
        
        u_type : {
            type : String,
            required: true
        }
    },
    
    data() {
        return {
            view_action  : null
        }
    },
    
    mounted() {
        this.getInfo();
    },
    
    methods: {
        
        async getInfo () {
            this.view_action = null;
            await api.get('/memorandums/' + this.doc_id + '/watch/' + this.u_type + '/' + this.user_id ).then(({data}) => {
                if(data.status === "operation_success") {
                    this.view_action = data.data;
                }
            }).catch(err => {
                console.log(err);
            });
        },
    },
    
    computed : {
        added_text () {
            try {
                return this.view_action.added
            }
            catch (e) {
                console.log(e);
            }
        }
    },
    
    
}
</script>

<style scoped>

</style>